module.exports = __webpack_public_path__ + "static/media/reverse-gradient.d74a1a82.svg";